<template>
    <div class="bg">
        <img class="btn-back" src="@/assets/icon_back.png" alt="" @click="goBack">
        <div class="t1" :class="{'t1-en': lang == 'en'}">{{this.$t('yqm.title')}}</div>
        <div class="t2" :class="{'t1-en': lang == 'en'}">{{this.$t('yqm.yq')}}<span class="t3">{{this.$t('yqm.zyj')}}</span></div>
        <div class="invite-wrap">
            <div class="invite-box">
                <div class="invite-tips" data-localize="wdtg.wdyqlj">{{this.$t('yqm.wdyqlj')}}</div>
                <div class="input-wrap">
                    <div class="input-box"><input class="input" type="text" id="link" v-model="url"></div>
                    <img class="icon" src="@/assets/copy2.png" @click="copy1($event)" alt="">
                </div>
                <div class="invite-tips" data-localize="wdtg.wdyqm">{{this.$t('yqm.wdyqm')}}</div>
                <div class="input-wrap">
                    <div class="input-box"><input class="input" type="text" id="code" v-model="code"></div>
                    <img class="icon" src="@/assets/copy2.png" @click="copy2($event)" alt="">
                </div>
                <div class="btn" data-localize="wdtg.schbyq" @click="haibaoAlert">{{this.$t('yqm.schbyq')}}</div>
            </div>
        </div>
        <div class="mask" v-show="isShow"></div>
        <div class="alert-share" :class="{active: isShow}">
            <div id="imgBox" class="img-box"><img class="img" v-if="lang == 'zh' || lang == 'tw'" src="@/assets/share_chinese.png" alt=""><img class="img" v-else src="@/assets/share_english.png" alt=""><div id="code" class="code"><qriously :value="url" :size="70"/></div></div>
            <div class="share-foot">
                <!-- <div class="title" data-localize="wdtg.fxd">分享到</div> -->
                <div class="share-box">
                    <!-- <div class="share">
                        <img class="icon" src="./images/Wechat.png" alt="">
                        <p data-localize="wdtg.wxhy">微信好友</p>
                    </div>
                    <div class="share">
                        <img class="icon" src="./images/Circle-of-friends.png" alt="">
                        <p data-localize="wdtg.wxpyq">微信朋友圈</p>
                    </div> -->
                    <a class="share" href="" download="download" id="saveImg">
                        <img class="icon" src="@/assets/picture.png" alt="">
                        <p data-localize="wdtg.bctp">{{this.$t('yqm.bctp')}}</p>
                    </a>
                </div>
                <div class="btn-cancle" @click="cancle" data-localize="wdtg.qx">{{this.$t('yqm.qx')}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import '@/utils/jquery-1.8.3.min.js'
import html2canvas from 'html2canvas';
import VueQriously from 'vue-qriously'
export default {
    name: 'invitation',
    data () {
        return {
            isShow: false,
            navIndex: 0,
            url: '',
            code: '',
            myEarnings: '',
            data:{},
            list:[],
            lang: 'zh'
        }
    },
    created() {
        let code = this.code = this.$route.params.code;
        this.lang = localStorage.getItem('user_lang');
        let domain = window.location.host + '/reg';
		this.url = domain + '?code=' + code;
	},
    mounted() {

	},
    methods: {
        nav:function(index){
			this.navIndex = index
			this.getMyPromotion()
		},
		copy1(e){
            let url = this.url;
            this.$copyText(url, this.$t('chongbi.fzcg'));
            this.$toast.center(this.$t('chongbi.fzcg'));
        },
        copy2(e){
            let code = this.code;
            this.$copyText(code, this.$t('chongbi.fzcg'));
            this.$toast.center(this.$t('chongbi.fzcg'));
        },
		haibaoAlert(){
			this.isShow = true;
			$('html').scrollTop(0)
			this.haibao();
		},
		haibao(){//生成canvas
			html2canvas(document.querySelector("#imgBox"),{
				width: 302,
				height: 440,
			}).then((canvas) => {
				this.canvasToImage(canvas)
			});
		},
		canvasToImage(canvas){//canvas 生成图片
			var image = new Image();
			image.src = canvas.toDataURL("image/png");
			$('#saveImg').attr('href',image.src)
		},
        cancle(){
            this.isShow = false;
		},
		goBack(){
			this.$router.go(-1);
		}
    }
}
</script>
<style scoped>
    .bg{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: auto;
        height: auto;
        padding: 0 16px;
        background-image: url('./../assets/Invitation-background.png');
        background-size: cover;
        overflow-y: auto;
    }
    .btn-back{
        position: fixed;
        top: 10px;
        left: 14px;
        z-index: 99;
        width: 24px;
        height: 30px;
        opacity: 0;
    }
    .t1{
        padding: .7rem 0 .2rem;
        color: #fff;
        font-size: .52rem;
        font-weight: bold;
        text-align: center;
    }
    .t2{
        color: #fff;
        font-size: .68rem;
        font-weight: bold;
        text-align: center;
    }
    .t1-en{
        font-size: .4rem;
    }
    .t3{
        color: #FFF587;
    }
    .invite-wrap{
        position: relative;
        top: 4.2rem;
        padding: .16rem;
        border-radius: .08rem;
        background: #7f80ef;
    }
    .invite-wrap .invite-box{
        padding: 0 .28rem .78rem;
        border-radius: .08rem;
        background: #fff;
    }
    .invite-wrap .invite-tips{
        padding: .28rem 0;
        color: #000;
        font-size: .28rem;
    }
    .invite-wrap .input-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .invite-wrap .input-wrap .input-box{
        flex: 1;
        height: .68rem;
        line-height: .68rem;
        border-radius: .07rem;
        background: #F1F1FC;
    }
    .invite-wrap .input-wrap .input{
        width: 100%;
        padding: 0 .32rem;
        color: #000;
        font-size: .28rem;
        box-sizing: border-box;
        background: transparent;
    }
    .invite-wrap .input-wrap .icon{
        margin-left: .2rem;
        width: .48rem;
        height: .48rem;
    }
    .invite-wrap .invite-box .btn{
        width: 3.76rem;
        height: .68rem;
        margin: .68rem auto 0;
        color: #fff;
        font-size: .28rem;
        line-height: .68rem;
        background: linear-gradient(0deg, #4A84F0, #7447E2);
        border-radius: .3rem;
        text-align: center;
    }
    .mt8{
        margin-top: 8px;
    }
    .invite-wrap .invite-box .title{
        padding: 16px 0 12px;
        color:#8b8b8b;
    }
    .invite-wrap .invite-box .price{
        color:#000;
        font-size: 16px;
        font-weight: bold;
    }
    .invite-wrap .invite-box .ul-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 0 0;
    }
    .invite-wrap .invite-box .ul-box .t1{
        color: #8b8b8b;
        font-size: 12px;
        text-align: center;
    }
    .invite-wrap .invite-box .ul-box .t2{
        margin-top: 12px;
        color: #000;
        font-weight: bold;
        text-align: center;
    }
    .alert-share{
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 1000;
        width: 0;
        overflow: hidden;
    }
    .alert-share.active{
        width: 100%;
        overflow: initial;
    }
    .alert-share .img-box{
        position: absolute;
        bottom: 186px;
        width: 302px;
        left: 50%;
        margin-left: -151px;
    }
    .alert-share .img-box .img{
        width: 302px;
        height: 440px;
    }
    .alert-share .img-box .code{
        position: absolute;
        left: 13px;
        bottom: 2px;
        width: 70px;
        height: 70px;
    }
    .alert-share .share-foot{
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: .2rem .36rem .06rem;
        background: #fff;
        box-sizing: border-box;
    }
    .alert-share .share-foot .title{
        color: #000;
        font-size: 16px;
        text-align: center;
    }
    .alert-share .share-foot .share-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0 16px;
    }
    .alert-share .share-foot .share-box .icon{
        width: 36px;
        height: 36px;
    }
    .alert-share .share-foot .share-box .share{
        flex: 1;
        color: #7f7f7f;
        font-size: 13px;
        text-align: center;
    }
    .alert-share .btn-cancle{
        height: 30px;
        color: #666;
        line-height: 30px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/invitation.vue